var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"tw-text-sm tw-border-separate tw-break-normal tw-border-spacing-0 tw-border tw-border-gray-300 tw-rounded-md tw-overflow-hidden tw-table-fixed"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }